<template>
  <div
    ref="loadmore"
    class="loadmore"
  />
</template>
<script>
import lodash from 'lodash'

/**
 * @type {import('vue').Component}
 */
const HKLLoadMore = {
  name: 'HKLLoadMore',
  props: {
    watchElement: {
      type: HTMLElement,
      default: () => document.body,
    },
  },
  data () {
    return {
      id: undefined,
    }
  },
  watch: {
    watchElement () {
      this.startLinstener()
    },
  },
  mounted () {
    this.startLinstener()
  },
  methods: {
    startLinstener () {
      this.watchElement.onscroll = (() => {
        /**
         * @type {HTMLElement}
         */
        const par = this.watchElement
        /**
         * @type {HTMLElement}
         */
        const more = this.$refs.loadmore
        const flag = Symbol('id')
        this.id = flag
        if (!par) return () => {}
        return lodash.debounce(() => {
          if (this.id !== flag) return
          if (!(par.scrollTop + par.offsetTop + par.clientHeight > more.offsetTop)) return
          this.$emit('loadmore')
        }, 25)
      })()
    },
  },
}

export default HKLLoadMore
</script>
<style lang='scss' scoped>
.loadmore {
  width: 100%;
  min-height: 1px;
}
</style>
